import type { IPersonalDataProtectionStorage } from '../../interfaces/personal-data-protection-persistence.storage';
import type { IPersonalDataProtectionPolicy } from '../../interfaces/personal-data-protection-policy.interface';
import type { IConsentState, TConsentType } from '../../types';
import { Source } from '../../types';

enum GDPRPolicyStates {
    Disagreement = '0',
    Agreement = '1',
    NotAnswered = 'n/a',
}

export class GDPRPolicy implements IPersonalDataProtectionPolicy {
    private readonly gdprKey = 'gdpr_answer';

    constructor(private readonly store: IPersonalDataProtectionStorage) {
        const value = this.store.get<string>(this.gdprKey, null);
        const isValueNotExistInGDPRStates = Object.keys(GDPRPolicyStates).every(
            (key) => GDPRPolicyStates[key] !== value
        );

        if (isValueNotExistInGDPRStates) {
            this.store.set(this.gdprKey, GDPRPolicyStates.NotAnswered);
        }
    }

    public isConsentRequired(consentType: TConsentType, source: Source): boolean {
        const value = this.store.get<string>(this.gdprKey, null);

        if (source === Source.Page) {
            return value !== GDPRPolicyStates.Disagreement && value !== GDPRPolicyStates.Agreement;
        } else {
            return value !== GDPRPolicyStates.Agreement;
        }
    }

    public getGlobalConsentState(): IConsentState {
        return {
            default: this.store.get<string>(this.gdprKey, GDPRPolicyStates.Disagreement) === GDPRPolicyStates.Agreement,
        };
    }

    public saveConsent(result: IConsentState): void {
        const valueToSave = result.default === true ? GDPRPolicyStates.Agreement : GDPRPolicyStates.Disagreement;
        this.store.set(this.gdprKey, valueToSave);
    }
}
